import { useState, useEffect } from "react";
import { LABEL } from "@/data/catalog";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "releases", label: "Releases" },
  { id: "manifesto", label: "Manifesto" },
  { id: "roster", label: "Roster" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-500 ${
        scrolled ? "bg-void/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3 group">
          <span className="h-2.5 w-2.5 bg-signal rounded-full group-hover:scale-125 transition-transform" />
          <span className="font-mono uppercase tracking-[0.25em] text-xs md:text-sm text-white">
            Smoke Shop <span className="text-signal">Records</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="font-mono uppercase tracking-[0.2em] text-xs text-white/60 hover:text-signal transition-colors"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-subscribe"
            href={LABEL.channel}
            target="_blank"
            rel="noreferrer"
            className="font-mono uppercase tracking-[0.2em] text-xs px-5 py-2.5 bg-signal text-void hover:bg-white transition-colors"
          >
            Subscribe
          </a>
        </nav>

        <button data-testid="nav-menu-toggle" className="md:hidden text-white" onClick={() => setOpen((o) => !o)}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-void border-b border-white/10 px-5 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="font-mono uppercase tracking-[0.2em] text-sm text-white/70 text-left">
              {l.label}
            </button>
          ))}
          <a href={LABEL.channel} target="_blank" rel="noreferrer" className="font-mono uppercase tracking-[0.2em] text-sm text-signal">
            Subscribe →
          </a>
        </div>
      )}
    </header>
  );
};
